import {useState} from "react";
import type {ArticleBase} from "./ArticleBasePicker";
import {supabase} from "../lib/supabase";
export default function Bc3ArticleSource({source}:{source:NonNullable<ArticleBase["metadata"]["bc3_import"]>}) {
 const [busy,setBusy]=useState(false);const [error,setError]=useState("");
 async function download(){
  if(busy)return;setBusy(true);setError("");
  try{
   const {data,error:problem}=await supabase.rpc("get_bc3_library_original",{import_batch_id:source.batch_id});
   if(problem)throw problem;
   const original=data as {file_name:string;base64:string};
   const binary=atob(original.base64);const bytes=new Uint8Array(binary.length);
   for(let index=0;index<binary.length;index++)bytes[index]=binary.charCodeAt(index);
   const url=URL.createObjectURL(new Blob([bytes],{type:"application/octet-stream"}));
   const link=document.createElement("a");link.href=url;link.download=original.file_name;link.click();URL.revokeObjectURL(url);
  }catch(cause){setError(String((cause as {message?:string}).message ?? cause));}
  finally{setBusy(false);}
 }
 return <section className="card library-section" aria-label="Origem do ficheiro BC3">
  <h3>Origem BC3</h3>
  <p>Catálogo {source.namespace} · {source.file_name} · Tarifa {source.tariff_index+1}</p>
  <p>Indicação da origem no ficheiro: {source.source_owner || "Não indicada"} · {source.source_version || "Versão não indicada"}</p>
  {source.source_encoding ? <p>Leitura do texto: {source.source_encoding} · Indicação no ficheiro: {source.declared_encoding || "Não indicada"}</p> : null}
  <p>Datas declaradas no ficheiro: {source.declared_dates.length ? source.declared_dates.join(" · ") : "Não indicadas"}</p>
  <p className="muted">Estas datas são conservadas como constam no BC3. A data de importação não confirma a atualização dos preços.</p>
  {source.auxiliary_compositions?.length ? <details>
   <summary>Composições auxiliares da origem · {source.auxiliary_compositions.length}</summary>
   <p className="muted">O detalhe conserva os consumos e preços importados. Confirme os componentes antes de rever o preço do auxiliar na ficha principal.</p>
   {source.auxiliary_compositions.map(node=><details key={node.code}>
    <summary>{node.code} · {node.label} · {node.calculatedPrice.toLocaleString("pt-PT",{style:"currency",currency:"EUR"})} / {node.unit} na origem</summary>
    {node.description ? <p style={{whiteSpace:"pre-wrap"}}>{node.description}</p> : null}
    <div className="library-table-wrap"><table className="library-table">
     <thead><tr><th>Recurso</th><th>Consumo</th><th>Preço na origem</th><th>Parcial</th></tr></thead>
     <tbody>{node.resources.map(resource=><tr key={resource.code}>
      <td>{resource.code} · {resource.label}{resource.auxiliary ? <small>Composição auxiliar</small> : null}</td>
      <td>{resource.quantity.toLocaleString("pt-PT")} {resource.unit}</td>
      <td>{resource.unit_price.toLocaleString("pt-PT",{style:"currency",currency:"EUR"})}</td>
      <td>{resource.partial.toLocaleString("pt-PT",{style:"currency",currency:"EUR"})}</td>
     </tr>)}</tbody>
    </table></div>
   </details>)}
  </details> : null}
  <button type="button" className="button button-secondary" disabled={busy} onClick={()=>void download()}>{busy ? "A obter original…" : "Descarregar ficheiro BC3 original"}</button>
  {error ? <div className="alert alert-error" role="alert">{error}</div> : null}
 </section>;
}
